import React from 'react';
import { connect } from 'react-redux';
import withFeatureFlags from 'hocs/withFeatureFlags';
import * as actEmailNotification from 'actions/setting/emailNotification';
import { askConfirmAction } from 'actions/confirm-action';
import { browserHistory } from 'react-router';
import { isDirty, getFormValues } from 'redux-form';
import ConfirmActionModal from 'components/ConfirmActionModal';
import { PageWrapper } from 'components/wrappers/pages';
import MenuTitle from 'components/MenuTitle';
import { push } from 'react-router-redux';
import DeleteRecipientModal from './EmailNotificationForm/DeleteRecipientModal';
import Header from './Header';
import styles from './EmailNotification.css';
import EmailNotificationForm from './EmailNotificationForm';

class EmailNotification extends React.Component {
  render() {
    const {
      showDeleteRecipientModal,
      deletedRecipient,
    } = this.props.data.setting.emailNotification;
    const { emailNotificationForm } = this.props;
    return (
      <PageWrapper>
        <MenuTitle menuTitle="Email Notifications" column="12" />
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <Header title="manage email notification" />
            <p className={styles.description}>
              Receive emails on new products or how your business is performing.
              Emails are automatically sent to your account email.
            </p>
            <EmailNotificationForm onSubmit={this._onSubmit} />
          </div>
        </div>
        <DeleteRecipientModal
          showDeleteRecipientModal={showDeleteRecipientModal}
          deletedRecipient={deletedRecipient}
          dispatch={this.props.dispatch}
          emailNotificationForm={emailNotificationForm}
        />
        <ConfirmActionModal />
      </PageWrapper>
    );
  }

  _onSubmit = values => {
    let setting;
    if (this.props.emailNotificationSettingRestrictions) {
      setting = this.props.data.setting.emailNotification.businessSettings;
    } else {
      setting = this.props.data.setting.emailNotification.profile.business
        .setting;
    }
    setting.daily_sales_summary = values.dailySalesSummary;
    setting.inventory_alerts = values.inventoryAlerts;
    setting.promo_update_notif = values.promoUpdateNotif;
    setting.product_updates = values.productUpdates;
    setting.setting_alert_recipients = values.settingAlertRecipients;
    this.props.dispatch(
      actEmailNotification.submitForm(
        { settings: { ...setting } },
        this.props.emailNotificationSettingRestrictions
      )
    );
  };

  componentDidMount() {
    browserHistory.listenBefore(location => {
      if (this.props.data.isDirtyForm && !this.props.nextAction) {
        this.props.dispatch(askConfirmAction(push(location.pathname)));
        return false;
      }
    });
    this.props.dispatch(
      actEmailNotification.pageRequest(
        this.props.emailNotificationSettingRestrictions
      )
    );
  }
}

function mapStateToProps(state) {
  return {
    emailNotificationForm: getFormValues('emailNotification')(state),
    data: {
      isDirtyForm: isDirty('emailNotification')(state),
      setting: {
        emailNotification: state.setting.emailNotification,
      },
    },
    nextAction: state.confirmAction.nextAction,
  };
}

function mapFlagsToProps(flags) {
  return {
    emailNotificationSettingRestrictions:
      flags.emailNotificationSettingRestrictions,
  };
}

export default withFeatureFlags(mapFlagsToProps)(
  connect(mapStateToProps)(EmailNotification)
);
